import { NextImage, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import { useI18n } from 'next-localization';
import { useMemo } from 'react';
import { SiteSelector } from 'src/model/Site';

type MobileMenuSiteSelectorProps = {
  siteSelectorProperty: SiteSelector;
  changeSiteHandler: () => void;
};

const MobileMenuSiteSelector = ({
  siteSelectorProperty,
  changeSiteHandler,
}: MobileMenuSiteSelectorProps) => {
  const { t } = useI18n();

  const siteSelectorItems = useMemo(() => {
    return siteSelectorProperty.vectors;
  }, [siteSelectorProperty]);

  return (
    <div className="mobile-site-selector">
      {siteSelectorItems.map((item, index) => (
        <div key={index} className="site-selector__item">
          <div className="site-selector__item__heading d-flex align-items-center px-2 px-md-4">
            <NextImage
              field={item.icon}
              width="50"
              height="32"
              className="background-to-change me-2"
            />
            <Text tag="h4" field={item.heading} />
          </div>
          <Text
            tag="p"
            field={item.description}
            className="site-selector__item__description px-2 px-md-4 mt-3 body-small"
          />
          {item.links.length && (
            <ul className="site-selector__item__links mt-2">
              {item.links.map((cta, idx) => (
                <li key={idx}>
                  <ScLink
                    field={cta.link}
                    onClick={changeSiteHandler}
                    replaceWithSlot={false}
                    showExternalIcon={false}
                    className={`${
                      cta.isSelected.value ? 'active' : ''
                    } site-selector__item__link py-2 meganav-link meganav-link--small d-flex align-items-center px-2 px-md-4`}
                  >
                    <i className="bi bi-chevron-down" />
                  </ScLink>
                </li>
              ))}
            </ul>
          )}
          <hr
            className={`${[
              item.links.length ? 'mt-2' : 'mt-4',
              siteSelectorItems.length === index + 1 ? 'mb-2' : 'mb-4',
            ]} vector-divider ms-2 me-2 ms-md-4 me-md-4`}
          />
        </div>
      ))}
      <ScLink
        field={siteSelectorProperty.changeCountryCta}
        className="site-selector__change-country site-selector__item__link meganav-link meganav-link--small d-flex align-items-center px-2 py-2 px-md-4"
        showExternalIcon={false}
        replaceWithSlot={true}
        onClick={changeSiteHandler}
      >
        <NextImage
          field={siteSelectorProperty.changeCountryIcon}
          className="background-to-change link-icon me-2"
          width="50"
          height="28"
        />
        <span>{t('changeCountrySite')}</span>
        <i className="bi bi-chevron-right link-chevron ms-auto" />
      </ScLink>
    </div>
  );
};

export default MobileMenuSiteSelector;
